import { useCallback } from "react";
import { Button, Group, Table, Text } from "@mantine/core";
import type { ReportReviewMatrixPathologist } from "../../../services/admin/reportReviewSettings.service";

interface ReportReviewMatrixHeaderProps {
  pathologists: ReportReviewMatrixPathologist[];
  disabled: boolean;
  onPathologistChange: (pathologistUserId: string, required: boolean) => void;
}

export function ReportReviewMatrixHeader({
  pathologists,
  disabled,
  onPathologistChange,
}: ReportReviewMatrixHeaderProps) {
  const handleRequire = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      onPathologistChange(event.currentTarget.dataset.pathologistId!, true);
    },
    [onPathologistChange]
  );
  const handleMakeOptional = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      onPathologistChange(event.currentTarget.dataset.pathologistId!, false);
    },
    [onPathologistChange]
  );

  return (
    <Table.Thead>
      <Table.Tr>
        <Table.Th
          scope="col"
          pos="sticky"
          left={0}
          bg="var(--mantine-color-body)"
          miw={220}
          style={{ zIndex: 2 }}
        >
          Prefix
        </Table.Th>
        {pathologists.map((pathologist) => (
          <Table.Th key={pathologist.id} scope="col" miw={190}>
            <Text fw={700}>{pathologist.fullName}</Text>
            <Text size="xs" c="dimmed" style={{ minHeight: 20 }}>
              {pathologist.credentials}
            </Text>
            <Group gap={4} mt={4} wrap="nowrap">
              <Button
                size="compact-xs"
                data-pathologist-id={pathologist.id}
                onClick={handleRequire}
                disabled={disabled}
              >
                Require review
              </Button>
              <Button
                size="compact-xs"
                variant="light"
                data-pathologist-id={pathologist.id}
                onClick={handleMakeOptional}
                disabled={disabled}
              >
                Make optional…
              </Button>
            </Group>
          </Table.Th>
        ))}
      </Table.Tr>
    </Table.Thead>
  );
}
